import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { SettingsService, ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Settings from './Settings';
import dayjs from 'dayjs';
import { useEffect } from 'react';

function SettingsContainer() {
    const {
        token,
        toast,
        settings,
        setSettings,
        fetchSetting,
        getDaysInMonth,
        months,
    } = useGlobalContext();
    const [loader, setLoader] = useState(false);
    const [watchLogs, setWatchLogs] = useState(false);

    const { register, watch, handleSubmit, setError, formState } = useForm({
        defaultValues: {
            mes_rango_DJCP_inicio:
                new Date(settings.djcp_rango_inicio).getMonth() + 1,
            dia_rango_DJCP_inicio: new Date(
                settings.djcp_rango_inicio
            ).getDate(),
            mes_rango_DJCP_fin:
                new Date(settings.djcp_rango_fin).getMonth() + 1,
            dia_rango_DJCP_fin: new Date(settings.djcp_rango_fin).getDate(),
            mes_vendimia_inicio:
                new Date(settings.cierre_vendimia).getMonth() + 1,
            dia_vendimia_inicio: new Date(settings.cierre_vendimia).getDate(),
            mes_djce_fecha_limite:
                new Date(settings.djce_fecha_limite).getMonth() + 1,
            dia_djce_fecha_limite: new Date(
                settings.djce_fecha_limite
            ).getDate(),
            // djce_fecha_limite: dayjs(settings.djce_fecha_limite).format(
            //     'YYYY-MM-DD'
            // ),
        },
    });

    const onSubmit = async (data) => {
        try {
            setLoader(true);

            const CurrentYear = new Date().getFullYear();

            const updateSettings = await SettingsService.update({
                token,
                ajustes: {
                    djcp_rango_inicio: new Date(
                        CurrentYear,
                        data.mes_rango_DJCP_inicio - 1,
                        parseInt(data.dia_rango_DJCP_inicio)
                    ),
                    djcp_rango_fin: new Date(
                        CurrentYear + 1,
                        data.mes_rango_DJCP_fin - 1,
                        parseInt(data.dia_rango_DJCP_fin)
                    ),
                    cierre_vendimia: new Date(
                        CurrentYear,
                        data.mes_vendimia_inicio - 1,
                        parseInt(data.dia_vendimia_inicio)
                    ),
                    djce_fecha_limite: new Date(
                        CurrentYear,
                        data.mes_djce_fecha_limite - 1,
                        parseInt(data.dia_djce_fecha_limite)
                    ),
                    // djce_fecha_limite: new Date(data.djce_fecha_limite),
                },
            });

            if (updateSettings) {
                setSettings(updateSettings.data);
            }

            setLoader(false);
            toast('Ajustes actualizados', { type: 'success' });
        } catch (err) {
            setLoader(false);
            toast('No se pudo actualizar los ajustes', { type: 'error' });
            return err;
        }
    };

    const onArcGisSync = async () => {
        try {
            setLoader(true);
            const SyncArcGis = await ViniedoService.syncArcGis({ token });

            if (SyncArcGis) {
                setLoader(false);
                toast(`${SyncArcGis.data} registros actualizados con éxito`, {
                    type: 'success',
                });
                fetchSetting();
            }
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    const InitialDays = getDaysInMonth(
        parseInt(watch('mes_rango_DJCP_inicio')) - 1,
        new Date().getFullYear()
    );
    const FinalDays = getDaysInMonth(
        parseInt(watch('mes_rango_DJCP_fin')) - 1,
        new Date().getFullYear()
    );
    const vendimiaDays = getDaysInMonth(
        parseInt(watch('mes_vendimia_inicio')) - 1,
        new Date().getFullYear()
    );
    const limiteDJCPDays = getDaysInMonth(
        parseInt(watch('mes_djce_fecha_limite')) - 1,
        new Date().getFullYear()
    );

    return loader ? (
        <Spinner />
    ) : (
        <Settings
            functions={{
                register,
                watch,
                handleSubmit,
                setError,
                formState,
                onSubmit,
                getDaysInMonth,
                setWatchLogs,
                onArcGisSync,
            }}
            states={{
                settings,
                months,
                InitialDays,
                FinalDays,
                vendimiaDays,
                watchLogs,
            }}
        />
    );
}

export default SettingsContainer;
